<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <button class="btn btn-sm btn-default btn-novo" @click="atualizar()" style="width: 33px" data-tooltip="Atualizar"><i class="fa fa-refresh" aria-hidden="true"></i></button>
        &nbsp;
        <button class="btn btn-sm btn-primary btn-novo" @click="novo()" style="width: 33px" data-tooltip="Novo"><i class="fa fa-plus" aria-hidden="true"></i></button>
        &nbsp;
        <!-- <export-excel
          :fields = "listaExcelFields"
          :fetch = "gerarExcel"
          type = "xls"
          worksheet = "Campanhas"
          name = "zanzar-campanhas.xls"
          class="btn btn-sm btn-primary btn-novo" style="width: 33px"
          data-tooltip="Exportar Excel"
        ><i class="fa fa-file-excel"></i></export-excel> -->
      </div>
    </div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :css="css.table"
      :sort-order="sortOrder"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-default': props.rowData.idc_status === 1,
            'label-warning': props.rowData.idc_status === 2,
            'label-info': props.rowData.idc_status === 3,
            'label-success': props.rowData.idc_status === 4,
            'label-danger': [5,9].includes(props.rowData.idc_status)
          }">{{ props.rowData.status_desc }}</span>
      </template>
      <!-- <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-sm btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
            <a @click="editar(props.rowData)" class="btn btn-sm btn-warning legitRipple" data-tooltip="Editar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-pencil"></span></a>
          </div>
        </div>
      </template> -->
    </vuetable>
    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'

import CampanhasActions from '../../actions/CampanhasActions'
import ActionsLogin from '../../actions/LoginActions'

export default {
  name: 'Integração',
  props: ['titulo', 'status'],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      css: VuetableCss,
      listaExcelFields: {
        'Codigo': 'cd_equipamento',
        'Codigo Player': 'cd_player',
        'Descricao': 'descricao',
        'Numero Serial': 'numero_serial',
        'Numero do Frame': 'mac_address',
        'Status': 'status_desc',
        'Local Atual': 'local_atual_desc',
        'Criado em': 'createdAt',
        'Alterado em': 'updatedAt'
      },
      filterText: '',
      urlApi: process.env.URL_API_BASE + '/controle-volume-mensagem/total-por-dia' + ((this.status !== null && this.status !== undefined) ? ('/listar-por-status/' + this.status) : ''),
      fields: [
        {
          name: 'data_exibicao',
          title: 'Data exibição',
          sortField: 'data_exibicao'
        },
        {
          name: 'qnt',
          title: 'Quantidade'
          // sortField: 'qnt'
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status'
        },
        // {
        //   name: 'local_atual_desc',
        //   title: 'Local Atual',
        //   sortField: 'local_atual_desc'
        // },
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'data_exibicao', direction: 'asc' }
      ],
      moreParams: {}
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Integração auditoria'

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  watch: {
    status: function (val) {
      if (this.status) {
        this.$parent.$parent.$data.description = this.titulo
        this.urlApi = process.env.URL_API_BASE + '/equipamento/listar-por-status/' + this.status
      } else {
        this.$parent.$parent.$data.description = 'Listar'
        this.urlApi = process.env.URL_API_BASE + '/equipamento'
      }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    atualizar () {
      this.doFilter()
    },
    novo () {
      this.$router.push('/campanhas/novo')
    },
    async gerarExcel () {
      let res = await CampanhasActions.listarEquipamento(this.status)
      return res
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/campanhas/Integracao.vue